// @flow

import React from 'react';
import moment from 'moment';
import styler from 'react-styling';
import radium from 'radium';
import { Grid, Row, Col } from 'react-bootstrap/lib';

import MeetingroomOverviewCarousel from './MeetingroomOverviewCarousel';
import MeetingRoomHeader from './MeetingRoomHeader';
import MeetingRoomFooter from './MeetingRoomFooter';
import getLanguage from '../../libs/Languages';

function _createStyle(theme: string) {
  return styler `
    Container
      background-color: ${theme === 'dark' ? '#14264C' : '#FFF'}
      width: 100%
      height: 100%
      color: ${theme === 'dark' ? '#FFF' : '#191919'}
      position: fixed
      top: 0
      left: 0
      z-index: 10000
    Description
      background-color: ${theme === 'dark' ? '#14264C' : '#FFF'}
      padding: 30px 30px 10px 30px
      font-size: 20px
      border-bottom: 1px solid ${theme === 'dark' ? '#0C1428' : '#CCC'}
    NextDayDate
      color: ${theme === 'dark' ? '#FFF' : '#191919'}
      font-size: 20px
      margin-right: 10px
  `;
}

type Props = {
  events: Array<Object>,
  languagedata: Object,
  clock: moment,
  theme: string,
  onToggle: Function,
  eventsFromNextDay: boolean,
};

export const MeetingroomOverview = (props: Props) => {
  const { clock, theme, eventsFromNextDay } = props;
  let { events } = props;
  const style = _createStyle(theme);
  const lang = getLanguage();
  // if show next day events slice the events array to show only three events.
  events = eventsFromNextDay ? events = events.slice(0, 3) : events;
  return (
    <div style={style.Container}>
      <MeetingRoomHeader text={lang.todays_meetings} clock={clock} theme={theme} />
      { events.length > 0 &&
      <Grid fluid>
        <Row className="hide-xs hide-sm" style={style.Description}>
          <Col xs={5} sm={6} md={7} lg={7}>{lang.room}</Col>
          <Col xs={5} sm={6} md={4} lg={5}>Time</Col>
        </Row>
      </Grid>
      }

      { events.length === 0 &&
      <Grid fluid>
        <Row style={style.Description}>
          <Col xs={12}>{lang.no_upcoming_events}</Col>
        </Row>
      </Grid>
      }

      {eventsFromNextDay && events.length > 0 ?
        <div>
          <Grid fluid>
            <Row style={style.Description}>
              <Col xs={12}>{lang.no_upcoming_events}</Col>
            </Row>
          </Grid>
          <div>
            <Grid fluid>
              <Row style={{ 'margin-top': '20%', ...style.Description }}>
                <Col xs={12}><span style={style.NextDayDate}>{props.clock.clone().add(1, 'day').format('dddd D. MMMM')}</span></Col>
              </Row>
            </Grid>
          </div>
        </div> : null}

      <MeetingroomOverviewCarousel events={events} clock={clock} theme={theme} />
      <MeetingRoomFooter theme={theme} onToggle={props.onToggle} />
    </div>
  );
};

export default radium(MeetingroomOverview);



// WEBPACK FOOTER //
// ./src/js/Components/MeetingRooms/MeetingroomOverview.js